import { TranslationKey } from './../../../types/translation/TranslationKey';

import React, { useRef, useState } from 'react';
import { Grid } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import CloseIcon from '@mui/icons-material/Close';
import '../../../style/FileDocument.scss';
import { testIds } from '../../../util/identifiers/identifiers.util';
import { handleKeyEvent } from '../../../util/events.util';

import { t } from '../../../types/translation/Translator';

interface UploadFileInputProps {
  onFile: (file: FileList | null) => void;
  file: File | null;
}

export default function UploadCsvInput({ onFile, file }: UploadFileInputProps) {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const [dragging, setDragging] = useState<boolean>(false);

  const openFilePicker = () => {
    if (fileInputRef && fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFilePickerChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    onFile(event.target.files);
  };

  const handleDrop = (event: React.DragEvent) => {
    event.preventDefault();
    setDragging(false);
    onFile(event.dataTransfer.files);
  };

  const handleRemoveFile = () => {
    onFile(null);
  };

  const browseContent = (
    <Grid
      container
      height={'300px'}
      alignContent={'center'}
      className='cursor-pointer select-none rounded border-2 border-dashed'
    >
      <Grid item xs={12} display='flex' justifyContent={'center'} className='text-blue-600'>
        <DriveFolderUploadIcon sx={{ fontSize: '3.5rem' }} />
      </Grid>
      <Grid item xs={12} textAlign={'center'} className='text-lg font-semibold text-blue-600'>
        <p>{t(TranslationKey.browse).singular.label}</p>
      </Grid>
      <Grid item xs={12} textAlign={'center'} className='text-sm text-gray-400'>
        <p>{t(TranslationKey.fileFormatCsv).singular.label}</p>
      </Grid>
    </Grid>
  );

  const dragContent = (
    <Grid
      container
      height={'300px'}
      alignContent={'center'}
      className='cursor-pointer select-none rounded border-2 border-dashed border-blue-600'
    >
      <Grid item xs={12} display='flex' justifyContent={'center'} className='text-blue-600'>
        <FileDownloadIcon sx={{ fontSize: '3.5rem' }} />
      </Grid>
      <Grid item xs={12} textAlign={'center'} className='text-lg font-semibold text-blue-600'>
        <p className='file_drag_and_drop browse'>{'Drop'}</p>
      </Grid>
      <Grid item xs={12} textAlign={'center'} className='text-sm text-gray-400'>
        <p className='file_drag_and_drop notice'>{'to upload .csv file'}</p>
      </Grid>
    </Grid>
  );

  return (
    <Grid
      container
      onClick={openFilePicker}
      onDrop={handleDrop}
      onDragOver={e => e.preventDefault()}
      onDragEnter={e => setDragging(true)}
      onDragLeave={e => setDragging(false)}
      tabIndex={0}
      onKeyDown={event => handleKeyEvent(event, 'Enter', openFilePicker)}
    >
      {!file ? (
        <Grid item xs={12}>
          {dragging ? dragContent : browseContent}
          <input
            data-testid={testIds.uploadCsvInput}
            ref={fileInputRef}
            onClick={(event: React.MouseEvent<HTMLInputElement>) => {
              event.currentTarget.value = '';
            }}
            accept={'.csv'}
            onChange={handleFilePickerChange}
            style={{ display: 'none' }}
            type='file'
          />
        </Grid>
      ) : (
        <Grid item xs={12}>
          <div className='relative flex h-80 cursor-pointer  select-none items-center justify-center rounded border-2 border-dashed'>
            <CloseIcon className='absolute right-2 top-2 text-red-300 hover:text-red-500' onClick={handleRemoveFile} />
            <div className='flex flex-col items-center justify-center gap-1'>
              <span className='fiv-viv fiv-icon-csv fiv-size-lg file_icon text-blue-600'></span>
              <p className='text-gray-400'>{file.name}</p>
            </div>
          </div>
        </Grid>
      )}
    </Grid>
  );
}
